// Google Analytics 4 (GA4) — caricato solo con consenso analitico e solo se il
// Measurement ID è configurato in REACT_APP_GA_MEASUREMENT_ID (formato G-XXXXXXXXXX).
// Nessun dato personale/testo libero/email viene mai inviato: solo eventi anonimi.
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "";
const CONSENT_COOKIE = "hairhelp_cookie_consent";

export function hasAnalyticsConsent() {
  try {
    const m = document.cookie.split("; ").find((c) => c.startsWith(`${CONSENT_COOKIE}=`));
    if (!m) return false;
    return JSON.parse(decodeURIComponent(m.split("=")[1])).analytics === true;
  } catch (e) {
    return false;
  }
}

export function initAnalytics() {
  if (!GA_ID) return; // Measurement ID non ancora fornito
  if (!hasAnalyticsConsent()) return; // rispetta il consenso cookie
  if (window.__gaLoaded) return; // evita duplicazioni del tag
  window.__gaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID, { anonymize_ip: true });
}

// Invia un evento (nome + parametri NON personali). Se GA non è attivo, resta nel dataLayer.
export function trackEvent(name, params = {}) {
  try {
    if (typeof window.gtag === "function") window.gtag("event", name, params);
    else (window.dataLayer = window.dataLayer || []).push({ event: name, ...params });
  } catch (e) {}
}
